import { mapActions, mapGetters, mapMutations } from "vuex";
import uiCounter from "@/components/@ui/counter/index.vue";

export default {
  name: "select-gift",
  components: { uiCounter },
  data() {
    return {
      draft: {},
    };
  },
  computed: {
    ...mapGetters({
      giftGroups: "gifts/giftGroups",
      selectedGifts: "gifts/selectedGifts",
    }),
    totalEarned() {
      return this.giftGroups.reduce((sum, g) => sum + (g.maxCount || 0), 0);
    },
    totalSelected() {
      return Object.values(this.draft).reduce(
        (sum, list) => sum + list.reduce((s, item) => s + item.count, 0),
        0
      );
    },
    canConfirm() {
      return this.giftGroups.every(group => this.selectedInGroup(group.id) === group.maxCount);
    },
  },
  watch: {
    giftGroups: {
      immediate: true,
      handler(next) {
        this.initDraft();
        if (!next || next.length === 0) {
          this.changeSelectGiftPopup(false);
        }
      },
    },
  },
  methods: {
    ...mapActions({
      applySelectedGifts: "gifts/APPLY_SELECTED_GIFTS",
    }),
    ...mapMutations({
      modalClose: "app/MODAL_CLOSE",
    }),
    changeSelectGiftPopup(status) {
      if (!status) this.modalClose("selectGift");
    },
    initDraft() {
      const next = {};
      this.giftGroups.forEach(group => {
        next[group.id] = (this.selectedGifts || [])
          .filter(item => item.giftGroupId === group.id)
          .map(item => ({ ...item }));
      });
      this.draft = next;
    },
    selectedInGroup(groupId) {
      const list = this.draft[groupId] || [];
      return list.reduce((sum, item) => sum + item.count, 0);
    },
    isVariantSelected(groupId, variant) {
      const list = this.draft[groupId] || [];
      return list.some(item => item.productPriceId === variant.productPriceId);
    },
    variantCount(groupId, variant) {
      const list = this.draft[groupId] || [];
      const found = list.find(item => item.productPriceId === variant.productPriceId);
      return found ? found.count : 0;
    },
    variantEffectiveMax(group, variant) {
      const variantLimit = variant.maxQuantity == null ? group.maxCount : variant.maxQuantity;
      return Math.min(group.maxCount, variantLimit);
    },
    showVariantCounter(group, variant) {
      return this.variantEffectiveMax(group, variant) > 1;
    },
    variantMax(group, variant) {
      const used = this.selectedInGroup(group.id);
      const current = this.variantCount(group.id, variant);
      const remaining = group.maxCount - used + current;
      return Math.min(remaining, this.variantEffectiveMax(group, variant));
    },
    setVariantCount(group, variant, nextCount) {
      const list = this.draft[group.id] ? [...this.draft[group.id]] : [];
      const idx = list.findIndex(item => item.productPriceId === variant.productPriceId);

      if (nextCount <= 0) {
        if (idx >= 0) list.splice(idx, 1);
      } else if (idx >= 0) {
        list[idx] = { ...list[idx], count: nextCount };
      } else {
        list.push({
          giftGroupId: group.id,
          productId: variant.product.id,
          productPriceId: variant.productPriceId,
          count: nextCount,
        });
      }

      this.$set(this.draft, group.id, list);
    },
    toggleVariant(group, variant) {
      const current = this.variantCount(group.id, variant);
      if (current > 0) {
        this.setVariantCount(group, variant, 0);
        return;
      }
      const used = this.selectedInGroup(group.id);
      if (used >= group.maxCount) return;
      this.setVariantCount(group, variant, 1);
    },
    confirm() {
      const flat = Object.values(this.draft).reduce((acc, list) => acc.concat(list), []);
      this.applySelectedGifts(flat);
      this.changeSelectGiftPopup(false);
    },
    close() {
      this.changeSelectGiftPopup(false);
    },
    resolveImage(variant) {
      const price = variant.product?.productPrices?.data?.find(
        p => p.id === variant.productPriceId
      );
      return price?.image || variant.productImage || variant.product?.image || "";
    },
    variantTitle(variant) {
      const price = variant.product?.productPrices?.data?.find(
        p => p.id === variant.productPriceId
      );
      return price?.title || variant.product?.productPrices?.data?.[0]?.title || "";
    },
  },
};
